import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { formatUuid } from "src/services/id";
import type * as GQL from "src/types/graphql";
import { ColumnId } from "./constants";

type Row = {
  id: { formId: uuid };
  attendingSchool: {
    id: string;
    name: string;
    referenceId?: string | null;
    status: GQL.attendance_status_type_enum;
  } | null;
};

const getAttendanceColumnProps = (columnId: ColumnId) => {
  switch (columnId) {
    case ColumnId.AttendanceStatus:
      return {
        header: "Attendance Status",
        valueFn: (attendingSchool: Row["attendingSchool"]) =>
          attendingSchool?.status,
      };
    case ColumnId.AttendingSchool:
      return {
        header: "Attending School",
        valueFn: (attendingSchool: Row["attendingSchool"]) =>
          attendingSchool?.name,
      };
    case ColumnId.AttendingSchoolId:
      return {
        header: `Attending School ID`,
        valueFn: (attendingSchool: Row["attendingSchool"]) =>
          formatUuid(attendingSchool?.id ?? ""),
      };
    case ColumnId.AttendingSchoolReferenceId:
      return {
        header: `Attending School Reference ID`,
        valueFn: (attendingSchool: Row["attendingSchool"]) =>
          attendingSchool?.referenceId ?? null,
      };
    default:
      throw new Error(`Unknown column ID: ${columnId}`);
  }
};

export function buildAttendanceColumnDef<T extends Row>(
  columnId: ColumnId
): ColumnDefWithTooltip<T> {
  const { header, valueFn } = getAttendanceColumnProps(columnId);
  return {
    accessorFn: (row) => valueFn(row.attendingSchool),
    id: columnId,
    header,
  };
}
